var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"evenodd"},[React.createElement("path",{"d":"M.92 13.834l.809.808a1 1 0 0 0 1.414 0l6.364-6.364a1 1 0 0 0 0-1.414L8.7 6.056a1 1 0 0 0-1.414 0L.92 12.42a1 1 0 0 0 0 1.414z","key":0}),React.createElement("path",{"d":"M8.7 9.08l.807-.809a1 1 0 0 0 0-1.414L3.143.493a1 1 0 0 0-1.414 0L.921 1.3a1 1 0 0 0 0 1.414L7.285 9.08a1 1 0 0 0 1.414 0z","key":1})]));
}

ChevronRight.defaultProps = {"width":"10","height":"15","viewBox":"0 0 10 15"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
